<div class="spreadsheet-toolbar">
  <div class="spreadsheet-download dropdown" [class.show]="downloadMenuOpen">
    <button class="btn btn-icon btn-sm" type="button" aria-label="Download spreadsheet"
      title="Download spreadsheet" aria-haspopup="menu" [attr.aria-expanded]="downloadMenuOpen"
      data-testid="spreadsheet-download-menu" (click)="downloadMenuOpen = !downloadMenuOpen">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-download" aria-hidden="true">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
        <path d="M7 11l5 5l5 -5" />
        <path d="M12 4v12" />
      </svg>
    </button>
    @if (downloadMenuOpen) {
      <div class="dropdown-menu dropdown-menu-end show" role="menu" aria-label="Spreadsheet formats">
        <button class="dropdown-item" role="menuitem" type="button" data-testid="spreadsheet-download-xlsx"
          (click)="download('xlsx')">Excel (.xlsx)</button>
        <button class="dropdown-item" role="menuitem" type="button" data-testid="spreadsheet-download-csv"
          (click)="download('csv')">CSV (.csv)</button>
      </div>
    }
  </div>
</div>

<div class="spreadsheet-grid" role="region" aria-label="Editable spreadsheet">
  <table class="table table-bordered table-sm mb-0">
    <thead>
      <tr class="spreadsheet-letters">
        <th class="spreadsheet-corner" aria-hidden="true"></th>
        @for (column of columns; track column.key; let columnIndex = $index) {
          <th scope="col">{{ columnLetter(columnIndex) }}</th>
        }
        <th class="spreadsheet-actions-column" aria-label="Row actions"></th>
      </tr>
      <tr>
        <th class="spreadsheet-row-number" aria-hidden="true">1</th>
        @for (column of columns; track column.key) { <th scope="col">{{ column.label }}</th> }
        <th class="spreadsheet-actions-column"></th>
      </tr>
    </thead>
    <tbody>
      @for (row of grid; track $index; let rowIndex = $index) {
        <tr>
          <th class="spreadsheet-row-number" scope="row">{{ rowIndex + 2 }}</th>
          @for (column of columns; track column.key; let columnIndex = $index) {
            <td>
              <input class="spreadsheet-cell" [attr.aria-label]="column.label + ', row ' + (rowIndex + 2)"
                [value]="cellValue(rowIndex, columnIndex)"
                (input)="updateCell(rowIndex, columnIndex, $any($event.target).value)" />
            </td>
          }
          <td class="spreadsheet-actions-column">
            <button class="btn btn-icon btn-sm btn-ghost-secondary" type="button" aria-label="Remove row"
              (click)="removeRow(rowIndex)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M5 7l1 14h12l1 -14"/><path d="M9 7v-3h6v3"/></svg>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
